// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"stat-card_wrapper__2Lqry","canvas":"stat-card_canvas__VrPpc","tooltip":"stat-card_tooltip__teLi5","tooltipItem":"stat-card_tooltipItem__1nMbT"};